const RemoveIcon = ({ ...props }) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="10" cy="10" r="9" fill="none" stroke="#A8B0B9" strokeWidth="2"/>
    <path d="M11.3728 14L9.87477 11.83L8.61477 14H6.02477L8.60077 10.01L5.95477 6.188H8.64277L10.1408 8.344L11.4008 6.188H13.9908L11.3728 10.122L14.0608 14H11.3728Z" fill="#A8B0B9"/>
  </svg>
);
export default RemoveIcon;